const NEW_ACCOUNT_WINDOW_MS = 30_000

type TIsNewlyCreatedAccountParams = {
	createdAt?: string
}

export const isNewlyCreatedAccount = ({
	createdAt,
}: TIsNewlyCreatedAccountParams) => {
	if (!createdAt) {
		return false
	}

	const createdAtMs = new Date(createdAt).getTime()
	if (Number.isNaN(createdAtMs)) {
		return false
	}

	return Date.now() - createdAtMs < NEW_ACCOUNT_WINDOW_MS
}
